module.exports = __webpack_public_path__ + "img/close_red.3de599e4.svg";